import { VueModule } from '@Foundation/utilities';
import HighlightedArticle from './code/Scripts/components/highlighted-article';

export default VueModule({
  components: {
    HighlightedArticle,
  },
});
